import { customersApi, samplesApi, locationsManagementApi } from '@/api';
import {
  sampleDescriptionsList,
  sectorsList,
  laboratories,
} from '@/config/constants';
import { filterOptions } from '@/config/enumOptions';

const reportStatusOptions = [
  {
    value: 'toBeApproved',
    label: 'enums.sampleReportStatuses.toBeApproved',
  },
  { value: 'approved', label: 'enums.sampleReportStatuses.approved' },
  { value: 'draft', label: 'enums.sampleReportStatuses.draft' },
];

const advancedRevisionFilters = [
  {
    name: 'sampleReportStatus',
    label: 'sampleReportStatus',
    type: 'select',
    whereOperator: 'inq',
    options: reportStatusOptions,
    customizeQueryString: (value) =>
      value === 'toBeApproved' ? 'toBeApproved,documentPending' : value, //  documentPending is for challenge
  },
  {
    name: 'sampleId',
    label: 'customerSampleId',
    type: 'number',
    whereOperator: '=',
  },
  {
    name: 'id',
    label: 'sampleId',
    type: 'autocomplete',
    whereOperator: '=',
    placeholder: 'Digita almeno 3 caratteri per cercare...',
    autocompleteSearch: async (queryString, cb) => {
      if (!queryString || queryString.trim().length < 3) {
        cb([
          {
            label: 'Digita almeno 3 caratteri per iniziare la ricerca',
            value: null,
            disabled: true,
          },
        ]);
        return;
      }
      const response = await samplesApi.autocompleteFetch(
        'labSampleCode',
        queryString,
        false
      );
      cb(response.data.map((c) => ({ label: c.labSampleCode, value: c.id })));
    },
  },
  {
    name: 'customerProductName',
    label: 'customerSampleCode',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'customerOrderNumber',
    label: 'customerOrderNumber',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'groupingId',
    label: 'grouping',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'lastReportDate',
    label: 'reportEmittedDate',
    type: 'dateRange',
  },
  {
    name: 'acceptedAt',
    label: 'receivedDate',
    type: 'dateRange',
  },
  {
    name: 'sampleAnalysisStart',
    label: 'sampleAnalysisStart',
    type: 'dateDay',
    whereOperator: 'gt',
  },
  {
    name: 'sampleAnalysisEnd',
    label: 'sampleAnalysisEnd',
    type: 'dateDay',
    whereOperator: 'lt',
  },
  {
    name: 'productCode',
    label: 'productCode',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sampleDescription',
    label: 'sampleDescription',
    type: 'select',
    filterable: true,
    whereOperator: '=',
    options: filterOptions(sampleDescriptionsList, 'enums.sampleDescriptions'),
  },
  {
    name: 'lot',
    label: 'lot',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sector',
    label: 'sector',
    type: 'select',
    whereOperator: '=',
    options: filterOptions(sectorsList, 'enums.sectors'),
  },
  {
    name: 'laboratory',
    label: 'department',
    type: 'select',
    whereOperator: '=',
    options: [
      { value: laboratories.CHIM, label: 'enums.laboratories.CHIM' },
      { value: laboratories.MICR, label: 'enums.laboratories.MICR' },
    ],
  },
  {
    name: 'locationId',
    label: 'locationIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const response = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      cb(response.data.map((c) => ({ label: c.name, value: c.id })));
    },
  },
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const response = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      cb(
        response.data.map((c) => ({ label: `${c.id} ${c.name}`, value: c.id }))
      );
    },
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
];

export default advancedRevisionFilters;
